export enum FieldType {
  STRING = 'string',
  DATE = 'date',
  TIME = 'time',
  CHECKBOX = 'checkbox',
  NUMBER = 'number',
  CURRENCY = 'currency',
  DROPDOWN = 'dropdown',
  RADIO = 'radio',
  SWITCH = 'switch',
  TEXTAREA = 'textarea',
}
